module.exports = __webpack_public_path__ + "img/holmesm.c48968d7.jpg";